<template>
  <div class="upload-area" @dragover="dragover" @dragleave="dragleave" @drop="drop" @click="$refs.file.click()">
    <img src="/images/upload-icon.svg" class="img-fluid" />
    <input type="file" :multiple="allowMultipleImages" name="file-input" class="file-input" @change="onChange" ref="file" accept=".jpg,.png" />
    <template v-if="!isUploading">
      <span v-show="!isDragging">Drag images to upload or <a>Browse</a></span>
      <span v-show="isDragging">Release to upload</span>
    </template>
    <template v-if="isUploading">
      <span>Uploading Images...</span>
    </template>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

export default {
  data() {
    return {
      isDragging: false,
      maxSize: 2097152, // 2Mb
      isUploading: false,
    };
  },
  props: {
    allowMultipleImages: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  methods: {
    async onChange() {
      const uploadedRawFiles = Array.from(this.$refs.file.files);
      const files = [];
      uploadedRawFiles.forEach((raw) => {
        if (raw.size <= this.maxSize) {
          files.push(
            new File([raw], `${uuidv4()}.${raw.type.toString().split('/')[1]}`, {
              type: raw.type,
              lastModified: raw.lastModified,
            })
          );
        } else {
          this.$bvToast.toast('One or more of your images are too big and were not uploaded. The maximum size for images is 2MB.', {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      });

      this.$emit('files-uploaded', files);

      this.$refs.file.files = null;
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.onChange();
      this.isDragging = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-area {
  border: #4e97b2 dashed 1px;
  padding: 20px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.3rem;
  cursor: pointer;

  a {
    text-decoration: underline;
    color: #4e97b2;
    pointer-events: all;
    cursor: pointer;
  }
}

.file-input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  width: 1px;
  height: 1px;
}
</style>
